import React, { useState, useEffect } from 'react';
import ContractorFilter from '../../components/Filter/ContractorFilter';
import ContractorMenu from './ContractorMenu';
import Pagination from '../../components/Pagination/ContractorPagination';
import { Link } from 'react-router-dom';
import { useMediaQuery } from '../../utils/useMediaQuery';

function ContractorIndex() {
  let tab = localStorage.getItem('contractorTabState');
  const isMobile = useMediaQuery('(max-width: 700px)');
  const [page, setPage] = useState('');

  useEffect(() => {
    if (tab === null) {
      localStorage.setItem('contractorTabState', 'all');
      setPage('all');
    }
    setPage(tab);
  }, [tab]);

  const handlePageFromMenu = (data) => {
    setPage(data);
  };

  return (
    <div className="w-full flex flex-1 mt-10 p-1">
      <div className="container relative flex flex-1 flex-col zero:flex-row mx-auto max-w-[1163px]">
        <div className={`flex flex-col gap-y-2 w-full ${page !== 'applicant' ? 'lg:w-3/4' : ''}`}>
          <div className="flex w-full px-4 lg:px-0 justify-between ">
            <h2 className="text-[25px] font-normal text-black">Контрагенты</h2>
            <Link to="/add/user">
              {' '}
              <button type="button" class="text-center border rounded py-2 px-4 mb-2 bg-button text-white hover:bg-button-hov mr-4 w-full 468:w-fit transition ease-in-out duration-300">
                Добавить {isMobile ? '' : 'контрагента'}
              </button>
            </Link>
          </div>
          <div className="flex flex-col w-full px-4 lg:px-0">
            <ContractorMenu sendDataToParent={handlePageFromMenu} />
          </div>
          <div className="flex w-full px-4 lg:px-0">
            <Pagination page={page} itemsPerPage={10} />
          </div>
        </div>
        {page !== 'applicant' ? (
          <div className="flex w-full lg:w-1/4 mt-10 px-4 lg:px-0">
            <ContractorFilter />
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  );
}

export default ContractorIndex;
